<div class="card border-0 shadow-sm h-100">
  @if (title) {
<div class="card-header bg-white border-bottom-0 text-center">
    <h5 class="card-title text-muted mb-0">{{ title }}</h5>
  </div>
}
    <div class="card-body d-flex align-items-stretch justify-content-center align-items-center">
    @if (isLoading) {
      <div class="w-100  h-100 text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
        </div>
      </div>
    } @else {
      @if (isChart) {
        <p-chart type="pie" [data]="data" [options]="options" />
      } @else {
        <div class="simple-value-widget text-center">
          <div class="display-4 fw-bold text-dark ">{{ data }}</div>
          <div class="text-muted">{{ legend }}</div>
        </div>
      }
    }
  </div>
</div>